module.exports = __webpack_public_path__ + "static/media/2_4.b17fa37b.png";